import styled from 'styled-components';

import { colorsPalettes } from '@similarweb/styles';

export const StyledCompanyOverview = styled.div`
  padding: 14px 24px;
`;

export const StyledSectionView = styled.div<{ withPadding?: boolean }>`
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  padding: ${({ withPadding }) => (withPadding ? '24px 16px 12px' : '24px 0 12px')};
  margin-bottom: 16px;
  border: 1px solid #f3f3f3;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  scroll-margin-top: 80px;
`;

export const StyledSeparator = styled.div`
  border-bottom: 0.5px solid ${colorsPalettes.carbon[50]};
  width: 100%;
  margin: 0 0 24px;
`;

export const StyledSectionBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
